import { render, staticRenderFns } from "./ticketsType.vue?vue&type=template&id=2d5094cd"
import script from "./ticketsType.vue?vue&type=script&lang=js"
export * from "./ticketsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports